import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import download_btn from "../../Admin/assets/icons/download_button.svg";
import instance from "../../Utils/api";
import { toast } from "react-toastify";
import cancel_consultation from '../../Admin/assets/icons/consultation-cancel-popup.svg'

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const CancelConsultation = ({
  openviewDialog,
  openviewCancelDialog,
  setopenviewDialog,
  setopenviewCancelDialog,
  customerdata,
  openDialog,
  setOpenDialog,
  edit,
  download,
  editData,
  handleConsultationData,
}) => {
  

  //handle close
  const handleClose = () => {
    setopenviewCancelDialog(false);
    setopenviewDialog(false);
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={edit ? openDialog : openviewDialog}
        className="admin-admins"
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <section className="add-consultantation">
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                 <div className="cancel-consultation-content">
              <img src={cancel_consultation} alt="" />
              <Typography variant="h4">Do you want to cancel the consultation</Typography>
              </div>
              </Grid>
            </Grid>
          </section>
        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Button className="cancel-btn" onClick={handleClose}>
            No
          </Button>
          <Button className='yes-btn'>Yes</Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default CancelConsultation;
